module.exports = __webpack_public_path__ + "static/media/swarm.4e55a9c9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/swarm.png
 ** module id = 234
 ** module chunks = 0
 **/